import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAdminCarouselStore = create(
	persist(
		(set) => ({
			pharmacy: null,
			root_pharmacy: null,
			data: null,
			platform: null,
			currentInfo: null,
			originProducts: null,
			setPharmacy: (pharmacy) => set({ pharmacy: pharmacy }),
			setRootPharmacy: (pharmacy) => set({ root_pharmacy: pharmacy }),
			setData: (data) => set({ data: data }),
			setPlatform: (platform) => set({ platform: platform }),
			setCurrentInfo: (data) => set({ currentInfo: data }),
			setOriginProducts: (products) => set({ originProducts: products }),
			resetCarouselStore: () =>
				set({
					pharmacy: null,
					root_pharmacy: null,
					data: null,
					platform: null,
					originProducts: null,
				}),
		}),

		{
			name: 'adminCarouselStorage',
			getStorage: () => sessionStorage,
		},
	),
);
